module.exports = __webpack_public_path__ + "img/type4_bg.a1f70084.png";